import React from "react";
import {
	BsFileEarmark,
	BsPlusCircle,
	BsSearch
} from "react-icons/bs";
import CircleArrowIcon from "../icon-button/circle-arrow-icon";


const iconMap = {
	search: BsSearch,
	plusCircle: BsPlusCircle,
	file: BsFileEarmark
};

export const resolveIcon = (icon, size = 20, iconProps = {}) => {
	if (!icon) {
		return null;
	}

	if (typeof icon !== "string") {
		return icon;
	}

	if (icon === "arrowRight") {
		return (
			<CircleArrowIcon
				direction="right"
				variant="legacy"
				{...iconProps}
			/>
		);
	}

	if (icon === "arrowLeft") {
		return (
			<CircleArrowIcon
				direction="left"
				variant="legacy"
				{...iconProps}
			/>
		);
	}

	if (icon === "circleArrowRight") {
		return <CircleArrowIcon size={size} direction="right" {...iconProps} />;
	}

	if (icon === "circleArrowLeft") {
		return <CircleArrowIcon size={size} direction="left" {...iconProps} />;
	}

	if (icon === "circleArrowDown") {
		return <CircleArrowIcon size={size} direction="down" {...iconProps} />;
	}

	if (icon === "circleArrowUp") {
		return <CircleArrowIcon size={size} direction="up" {...iconProps} />;
	}

	const Icon = iconMap[icon];

	if (!Icon) {
		return null;
	}

	return <Icon size={size} />;
};